// extracted by mini-css-extract-plugin
module.exports = {"container":"Disclaimer_container__Ixjhh","link":"Disclaimer_link__Dk3fk","button":"Disclaimer_button__ta3rm"};